import script from "./ChatContextBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatContextBar.vue?vue&type=script&setup=true&lang=js"

import "./ChatContextBar.vue?vue&type=style&index=0&id=457a0ff5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-457a0ff5"]])

export default __exports__